// extracted by mini-css-extract-plugin
module.exports = {"social_login_wrapper":"SocialLogin_social_login_wrapper__Kvz9R","top":"SocialLogin_top__AtPd4","login_buttons":"SocialLogin_login_buttons__1cPTc"};